import { facilityBookingService } from "@/services/facility/booking/booking.service";
import { alertService } from "@/services/alert/alert.service";
import {flightService} from "../../../../services/guest/flight/flight.service";
import {userService} from "../../../../services/facility/user/user.service";

export default {
    data: () => {
        return {
            data: {},
            dataReady: false,
            parking_id: null,
            actual_entry_date: '',
            actual_entry_time: '',
            actual_exit_date: '',
            actual_exit_time: '',
            form: {},
            cars: [],
            is_flight_use: false,
            flight: {},
            flight_schedules: {
                default: [{ label: '仙台', value: '仙台'}],
                departure: [],
                arrival: [],
            },
            flight_airlines: {
                departure: [],
                arrival: []
            },
            airline_companies: {
                departure: [],
                arrival: []
            },
            departure_ports: {},
            arrival_ports: {},
            redirect_back_uri: {
                fc: "facility-flight-cancellation.index",
            },
        };
    },
    async mounted() {
        if (this.$route.params.id) {
            await this.show(this.$route.params.id);
        }
    },
    methods: {
        async show(id) {
            await alertService.loading();
            // 予約情報を取得
            var response = await facilityBookingService.show(id);
            this.data = response.data;
            this.dataReady = true;
            this.parking_id = this.data.parking_id;
            this.form = {
                coupon_code: this.data.coupon_code,
                entry_date: this.data.entry_date,
                entry_time: this.data.entry_time,
                exit_date: this.data.exit_date,
                exit_time: this.data.exit_time,
                actual_entry: this.data.actual_entry,
                actual_exit: this.data.actual_exit,
                flight_use: this.data.flight_use,
                car_id: this.data.car_id,
                hiragana: this.data.car.hiragana,
                region: this.data.car.region,
                registered_number: this.data.car.registered_number,
                sort_number: this.data.car.sort_number,
                parking_id: this.data.parking_id,
                parking_type: this.data.parking.parking_type,
                created_at: this.data.created_at,
            };

            // 実入出庫時間を取得
            if(this.data.actual_entry){
                const actual_entry = new Date(this.data.actual_entry);
                this.actual_entry_date = this.formatDate(actual_entry);
                this.actual_entry_time = this.formatTime(actual_entry);
            }
            if(this.data.actual_exit){
                const actual_exit = new Date(this.data.actual_exit);
                this.actual_exit_date = this.formatDate(actual_exit);
                this.actual_exit_time = this.formatTime(actual_exit);
            }
            
            // フライト情報を取得
            if(this.data.flight_use == 1){
                this.is_flight_use = true;
                this.flight = this.data.flight_details;
                await this.reload_flight();
            }

            // 車両情報を取得
            var userResponse = await userService.list({
                user_id: this.data.user_id,
                paginate: 1,
                per_page: 10,
                page: 1
            });
            if(!userResponse.success){
                return;
            }
            const cars = userResponse.data.data[0].booking_user.car;
            for(const i in cars){
                const car = cars[i];
                car.display_name = `${car.region} ${car.sort_number} ${car.hiragana} ${car.registered_number}`;
            }
            this.cars = cars;
            alertService.close();
        },

        formatDate(dt) {
            var y = dt.getFullYear();
            var m = ('00' + (dt.getMonth()+1)).slice(-2);
            var d = ('00' + dt.getDate()).slice(-2);
            return `${y}-${m}-${d}`;
        },

        formatTime(dt){
            var h = ('00' + (dt.getHours())).slice(-2);
            var i = ('00' + (dt.getMinutes())).slice(-2);
            var s = ('00' + dt.getSeconds()).slice(-2);
            return `${h}:${i}:${s}`;
        },

        inputActual(key){
            if(key == 'actual-entry'){
                if(this.actual_entry_date == '' || this.actual_entry_time == ''){
                    this.form.actual_entry = '';
                    return;
                }
                this.form.actual_entry = `${this.actual_entry_date} ${this.actual_entry_time}`;
            }
            else if(key == 'actual-exit'){
                if(this.actual_exit_date == '' || this.actual_exit_time == ''){
                    this.form.actual_exit = '';
                    return;
                }
                this.form.actual_exit = `${this.actual_exit_date} ${this.actual_exit_time}`;
            }
        },

        changeCar(){
            if(!this.cars){
                return;
            }
            const filtered = this.cars.find((item) => 
                item.id == this.form.car_id
            );
            if(!filtered){
                return;
            }
            this.form.hiragana = filtered.hiragana;
            this.form.region = filtered.region;
            this.form.registered_number = filtered.registered_number;
            this.form.sort_number = filtered.sort_number;
        },

        changeFlightUse(){
            this.form.flight_use = this.is_flight_use == true;
        },

        async reload_flight(){
            if(this.flight.dep_flight_date){
                await this.selectFlightDate('departure', this.flight.dep_flight_date);
            }
            if(this.flight.dep_airline_code){
                await this.selectAirline('departure', this.flight.dep_airline_code);
            }
            if(this.flight.arr_flight_date){
                await this.selectFlightDate('arrival', this.flight.arr_flight_date);
            }
            if(this.flight.arr_airline_code){
                await this.selectAirline('arrival', this.flight.arr_airline_code);
            }
        },

        async selectFlightDate(mode, $event){
            let query = {
                departure_date: typeof($event) == 'string' ? $event : $event.target.value,
                paginate: 0
            }
            let result = await flightService.list(query);
            this.flight_schedules[mode] = result.data;
            this.airline_companies[mode] = result.data.filter((element, index, self) =>
                self.findIndex(e => e.airline_code == element.airline_code) === index
            );
            if(mode == 'departure'){
                this.departure_ports = result.data.filter((element, index, self) =>
                    self.findIndex(e => e.arrival_port == element.arrival_port) === index
                );
            }
            else{
                this.arrival_ports = result.data.filter((element, index, self) =>
                    self.findIndex(e => e.departure_port == element.departure_port) === index
                );
            }
        },

        async selectAirline(mode, $event){
            this.flight_airlines[mode] = this.flight_schedules[mode].filter(el => el.airline_code == $event);
            if(this.flight_airlines[mode].length <= 0){
                return;
            }
            const airline = this.flight_airlines[mode][0];
            if(mode == 'departure'){
                this.flight.dep_airline_company_jp = airline.airline_company_jp;
                this.flight.dep_airline_code = airline.airline_code;
            }
            else if(mode == 'arrival'){
                this.flight.arr_airline_company_jp = airline.airline_company_jp;
                this.flight.arr_airline_code = airline.airline_code;
            }
        },

        async selectAirlineCompany(mode, $event){
            this.flight_airlines[mode] = this.flight_schedules[mode].filter(el => el.airline_company_jp == $event);
            if(this.flight_airlines[mode].length <= 0){
                return;
            }
            const airline = this.flight_airlines[mode][0];
            if(mode == 'departure'){
                this.flight.dep_airline_code = airline.airline_code;
            }
            else if(mode == 'arrival'){
                this.flight.arr_airline_code = airline.airline_code;
            }
        },

        async update$(){
            var callback = async () => {
                await alertService.loading();
                await facilityBookingService.reservable({
                    reservation_id: this.$route.params.id,
                    airport_id : 1,
                    parking_id: this.parking_id,
                    entry_date: this.form.entry_date,
                    entry_time: this.form.entry_time,
                    exit_date: this.form.exit_date,
                    exit_time: this.form.exit_time,
                })
                .then(async (response) => {
                    if(response.data.status){
                        await facilityBookingService.update(this.$route.params.id, {...this.form, ...this.flight})
                        .then((response) => {
                            alertService.success(this.$t('facility.edit-booking.updated-successfuly'), this.$t('facility.edit-booking.reservation-updated-success'));
                        }).catch((error) => {
                            console.log(error);
                            alertService.error(this.$t('facility.global.error'), this.$t('facility.edit-booking.reservation-updated-failure'));
                        });
                    }
                    else{
                        alertService.error(this.$t('facility.global.error'), this.$t('facility.edit-booking.no-availability'));
                    }
                }).catch((error) => {
                    console.log(error);
                    alertService.close();
                });
            }
            alertService.confirmation(callback, this.$t("facility.global.confirmation"), this.$t("facility.global.are-you-sure"));

        },

        async back() {
            let r;
            if (this.$route.query.r) {
                r = {
                    name: this.redirect_back_uri[this.$route.query.r],
                };
                this.$router.push(r);
            } else {
                this.$router.go(-1)
            }
        },
    },
};
